import { createAction, props } from '@ngrx/store';

export const loadData = createAction('[App Component] Load data');
export const setShowPlansButton = createAction('[App Component] Set show plans button', props<{ payload: boolean }>());
export const setTourToPlanningMenu = createAction('[App Component] Set tour to planning menu');
